import * as qs from 'qs';

import { useAsyncValue, useRequestConnectedToAsyncValue } from '../..';
import { get } from '../../../redux/api';
import type { MinimalRevision } from '../../../shared/branches/types';
import { nuc } from '../../../utils';

type RevisionsResponse = {
  branch: Record<string, MinimalRevision[]>;
};

const fetchRevisions = (locator: string, branch: string, search?: string) => {
  const params = {
    refs: [branch],
    locator: search,
  };
  const queryString = qs.stringify(params, { arrayFormat: 'brackets' });
  return get<RevisionsResponse>(`/api/projects/${nuc(locator)}/revisions?${queryString}`);
};

/**
 * @deprecated - This pattern is outdated -- use useAsyncValue and friends (like useAsyncRequest) instead.
 */
const useFetchRevisions = () => {
  const asyncValue = useAsyncValue<RevisionsResponse>(null);
  const onFetchRevisions = useRequestConnectedToAsyncValue(
    fetchRevisions,
    asyncValue,
  ) as unknown as typeof fetchRevisions;

  // The RevisionsResponse contains a mapping of branches to available
  // revisions. However, since we only ever fetch on branch's revs at a
  // time (due to the `refs[0]=${branch}` param), we can safely grab the
  // only revisions present in the response.
  const branchIndex = asyncValue.value?.branch ?? {};
  const revisions = Object.values(branchIndex)[0] ?? [];

  return {
    onFetchRevisions,
    areRevisionsLoading: asyncValue.isLoading,
    revisions,
  };
};

export default useFetchRevisions;
